// Variaveis padrao exibidas nos gauges da tela /dashboard/customer/plant
// quando o operador AINDA NAO favoritou nada (ou favoritou poucas).
//
// Filosofia: a tela operacional deve ser util sem configuracao previa.
// Esses defaults garantem que o operador veja info relevante de cara —
// favoritar passa a ser personalizacao opcional, nao pre-requisito.
//
// Os IHM names abaixo precisam bater com os campos da subscription
// onUpdateIOT do backend. Se algum nome nao existir no allVariables
// retornado por getAllVariables, e silenciosamente ignorado — a UI
// degrada graciosamente.
//
// Mantenha listas curtas (6-8 vars) — o operador vai favoritar suas
// preferencias eventualmente. Defaults sao apenas o ponto de partida.

// UCHA (turbogerador): variaveis criticas para operacao de turbina
// hidraulica gerando energia.
export const UCHA_DEFAULTS = [
  'PotenciaAtivaMedia',
  'Vazao',
  'Rotacao',
  'TemperaturaAxial',
  'VibracaoAxial',
  'FatorPotenciaMedio',
];

// EBA (bomba): variaveis criticas para operacao de bomba consumindo
// energia para deslocar agua.
export const EBA_DEFAULTS = [
  'PotenciaAtivaMedia',
  'Vazao',
  'PressaoRecalque',
  'TemperaturaAxial',
  'VibracaoAxial',
  'CorrenteR',
];

// BLUEBOX: codigos curtos publicados pelo dispositivo. Esse fallback mantem
// os cards uteis mesmo quando o usuario ainda nao escolheu favoritos.
export const BLUEBOX_DEFAULTS = [
  'AccRMSZ',
  'TempCPU',
  'VSens',
  'VIn',
  'VCPU',
  'ActE',
];

// Retorna o array de IHM names default conforme o tipo da maquina.
// Default fallback para UCHA quando tipo desconhecido (mais comum no
// portfolio Higra).
export const getDefaultVariablesFor = (type) => {
  if (type === 'eba' || type === 'bomba') return EBA_DEFAULTS;
  if (type === 'bluebox') return BLUEBOX_DEFAULTS;
  return UCHA_DEFAULTS;
};

// Limite minimo de favoritos abaixo do qual os defaults aparecem em
// vez/junto. Definimos 0 — assim que o operador favorita PELO MENOS 1
// variavel, os defaults somem e respeitamos a escolha dele.
// (Se quiser sempre mostrar defaults faltantes ate completar X gauges,
// e so trocar essa logica em velocimetro.js.)
export const FAVORITES_MIN_TO_HIDE_DEFAULTS = 1;
